import React from 'react';
import QuotationFixedBottomCTA from '../Common/QuotationFixedBottomCTA';
import { QuotationHeaderBar } from '../Common';

import { ModalType } from './NotFoundQuotationContainer';

import { CustomizedButton, CustomizedTypography } from '@components/Customized';

import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { NOT_FOUND_PURCHASE_ORDER } from '../assets';

import {
  DRAWER_TITLE_BAR_HEIGHT,
  FIXED_BOTTOM_CTA_BAR_HEIGHT,
  GNB_HEIGHT
} from '@components/Chat/constants';

interface Props {
  isClosedConsulting: boolean;
  handleModal: (type: ModalType) => void;
}

const NotReceivedQuotationPresenter = ({
  isClosedConsulting,
  handleModal
}: Props) => {
  const classes = useStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  return (
    <>
      <QuotationHeaderBar hasQuotation={false} />
      <div className={classes.root}>
        <img
          src={NOT_FOUND_PURCHASE_ORDER}
          alt=""
          className={classes.notfound}
        />
        <CustomizedTypography
          align="center"
          color="textSecondary"
          variant="body1"
        >
          견적서를 수령하지 않고 회사소개서만 확인 후 시작한 상담입니다.
          <br />
          견적서가 필요하다면 견적서 발행을 요청해 주세요.
        </CustomizedTypography>
      </div>
      <QuotationFixedBottomCTA className={classes.fixedBottom}>
        <CustomizedButton
          disabled={isClosedConsulting}
          fullWidth={matches}
          variant="contained"
          color="primary"
          size="large"
          onClick={() => handleModal('quotation')}
        >
          견적서 발행요청
        </CustomizedButton>
      </QuotationFixedBottomCTA>
    </>
  );
};

export default NotReceivedQuotationPresenter;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: `calc(100vh - ${
      GNB_HEIGHT + DRAWER_TITLE_BAR_HEIGHT + FIXED_BOTTOM_CTA_BAR_HEIGHT
    }px)`,
    [theme.breakpoints.down('md')]: {
      height: `calc(100vh - ${
        FIXED_BOTTOM_CTA_BAR_HEIGHT + DRAWER_TITLE_BAR_HEIGHT
      }px)`
    }
  },
  notfound: {
    width: 137,
    height: 137,
    marginBottom: 32
  },
  fixedBottom: {
    '& button': {
      // maxWidth: 167,
    }
  }
}));
